export const notStartsWithNumber = val => val && !/^\d/.test(val)
export const alphaNumWithSpace = val => val && /^[a-z0-9 ]+$/i.test(val)
export const alphaNumWithDotAndUnderscore = val => val && /^[a-z0-9_.]+$/i.test(val)
export const hasSpecialCharacter = val => val && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(val)
export const hasNoSpaces = val => val && !(/\s/g).test(val)
export const hasNoDots = val => val && !(/\./g).test(val)
export const hasUniqueCharacters = (val, count) => {
    let uniqSrt = ''
    for (let x = 0; x < val.length; x++) {
        if (uniqSrt.indexOf(val.charAt(x)) === -1) {
            uniqSrt += val[x]
        }
    }
    if (count) {
        return uniqSrt.length >= count
    } else {
        return uniqSrt.length === val.length
    }
}
// simplified, without all Unicode characters
export const validJavaScriptName = val => (/^[a-zA-Z_$][0-9a-zA-Z_$]*$/).test(val)
